import { connect } from 'react-redux';

import DataDarkForm from './DataDarkForm.js';
// import { redux as apiRedux } from '../api';

const mapStateToProps = state => {
  return {
    user: state.api.user,
  };
};

const mapDispatchToProps = dispatch => {
  return {};
};

const ConnectedDataDarkForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(DataDarkForm);

export default ConnectedDataDarkForm;
